// src/modules/app-views/_apps/appmulti/leads/service.js
// *******************************************************************************
// HELPER FUNCTIONS FOR LEADS MODULE
// *******************************************************************************

// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { MdBoy, MdChildFriendly, MdDirectionsWalk, MdOutlineElderly } from 'react-icons/md';

// *******************************************************************************
// AGE BANDS
// *******************************************************************************
// Verbatim from backup List.jsx:134-167
// >= 60 → elderly, >= 18 → adult walking, >= 10 → boy, else → infant/child
const getAgeIcon = age => {
  if (age >= 60) return MdOutlineElderly;
  if (age >= 18) return MdDirectionsWalk;
  if (age >= 10) return MdBoy;
  return MdChildFriendly;
};

// *******************************************************************************
// SERVICE
// *******************************************************************************
const leadsService = { getAgeIcon };

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default leadsService;
